export enum ScanBatchDirection {
    In = "In",
    Out = "Out",
}
